module.exports = __webpack_public_path__ + "img/botan aniversario - Abigail Casanova.55f40c49.jpg";